import { render } from "./VisitTab.vue?vue&type=template&id=966844b0&scoped=true&ts=true"
import script from "./VisitTab.vue?vue&type=script&lang=ts"
export * from "./VisitTab.vue?vue&type=script&lang=ts"

import "./VisitTab.vue?vue&type=style&index=0&id=966844b0&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-966844b0"]])

export default __exports__